import {
  Background,
  Logo,
  Rodape,
  P,
  Container,
  Body,
  Center,
  DivBody,
} from "./HomeStyled";
import { Grid, Box } from "@material-ui/core";
import { useEffect } from "react";
import { goToLogin } from "../../routes/Coordinator";
import { useNavigate } from "react-router-dom";
import { Card, CardContent,Typography } from "@material-ui/core";

const HomePage = () => {

  const navigate = useNavigate();

  useEffect(() => {
    if(localStorage.getItem("access-token") === null || localStorage.getItem("client") === null || localStorage.getItem("uid") === null){
      goToLogin(navigate)
    }
  }, [])
  return (
    <Box

    id='Box1'>
      <Grid item xs={12} lg={12}>
        <Card
          variant="outlined"
          sx={{
            paddingBottom: "0",
          }}
        >
          <CardContent
            sx={{
              paddingBottom: "16px !important",
            }}
          ><Box
          sx={{
            display: {
              sm: "flex",
              xs: "block",
            },
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              fontFamily={'arial'}
              sx={{
                marginBottom: "0",
              }}
              gutterBottom
            >
              A fazer
            </Typography>
          </Box>
          </Box>
          </CardContent>
          </Card>
          </Grid>
        </Box>
        );
};

        export default HomePage;